module.exports = __webpack_public_path__ + "static/media/06-d-calendar.6396c5d5.png";